class BelovedGlyph {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._name = this.constructor.name
    }

    onInit () {
        var content = this._elem.innerHTML.replace(/(<([^>]+)>)/ig, '')
        content = content.replace('A', '<span class="ss02">A</span>')
        content = content.replace('B', '<span class="ss01">B</span>')
        content = content.replace('H', '<span class="ss02">H</span>')
        content = content.replace('K', '<span class="ss02">K</span>')
        content = content.replace('M', '<span class="ss01">M</span>')
        content = content.replace('N', '<span class="ss02">N</span>')
        content = content.replace('U', '<span class="ss01">U</span>')
        content = content.replace('V', '<span class="ss02">V</span>')
        content = content.replace('W', '<span class="ss02">W</span>')
        content = content.replace('X', '<span class="ss01">X</span>')
        content = content.replace('Y', '<span class="ss01">Y</span>')
        this._elem.innerHTML = content
        this._elem.classList.add('beloved-glyph--ready')
    }
}

export default BelovedGlyph



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BelovedGlyph.js